import React from 'react';
import { isIE } from '../../../Share/utils';
import {
  Modal,
  TextField,
  TFVButton,
  Translate,
} from '../../../Share/components';
import { ValidatorForm } from 'react-form-validator-core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createLicenseUser } from '../../actions';

function CreateUser({
  isVisible = false,
  onClose = () => {},
  onCreateUser = () => {},
  licenseIdentifier = null,
}) {
  const [username, setUsername] = React.useState('');
  const ref = React.useRef();

  const handleSubmit = async () => {
    if (ref.current && ref.current.isFormValid()) {
      const isSuccess = await onCreateUser(licenseIdentifier, username);
      if (isSuccess) {
        onClose();
        setUsername('');
      }
    }
  };

  return (
    <Modal
      isVisible={isVisible}
      onCloseClicked={() => {
        onClose();
        setUsername('');
      }}
      headerText="Skapa användare"
      className="tv-create-license__modal tv-create-license-user__modal"
      headerClassName="tv-create-license__modal-header"
      ieOptionClassName={isIE ? 'ie-fix-height' : ''}
    >
      <ValidatorForm ref={ref} onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Användarnamn</label>
          <TextField
            placeholder="Ange användarnamn (ej mellanslag eller stora bokstäver)"
            maxLength={100}
            className="text-field-style ellipsis pl-3 py-1 tv-single-assign-form__control"
            aria-label="Användarnamn"
            name="username"
            id="username"
            onChange={e => setUsername(e.target.value)}
            value={username}
            validators={['required']}
            errorMessages={['Användarnamn är obligatoriskt']}
          />
        </div>
        <div className="justify-content-between tv-display-flex gap-4 tv-create-license__modal__footer">
          <TFVButton
            type="line-primary"
            buttonType="button"
            className="w-50"
            text="Stäng"
            onClick={() => {
              onClose();
              setUsername('');
            }}
          />
          <TFVButton
            type="secondary"
            buttonType="submit"
            className="w-50"
            text="Skapa användare"
          />
        </div>
      </ValidatorForm>
    </Modal>
  );
}

CreateUser.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  onCreateUser: PropTypes.func,
  licenseIdentifier: PropTypes.string,
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({
  onCreateUser: (licenseIdentifier, username) =>
    dispatch(createLicenseUser(licenseIdentifier, username)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateUser);
